import { render, staticRenderFns } from "./SpeciesSelector.vue?vue&type=template&id=cd20296e&scoped=true&"
import script from "./SpeciesSelector.vue?vue&type=script&lang=js&"
export * from "./SpeciesSelector.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesSelector.vue?vue&type=style&index=0&id=cd20296e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd20296e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd20296e')) {
      api.createRecord('cd20296e', component.options)
    } else {
      api.reload('cd20296e', component.options)
    }
    module.hot.accept("./SpeciesSelector.vue?vue&type=template&id=cd20296e&scoped=true&", function () {
      api.rerender('cd20296e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/main/SpeciesSelector.vue"
export default component.exports